module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"apiCheck","amd":"api-check","commonjs2":"api-check","commonjs":"api-check"}
 ** module id = 3
 ** module chunks = 0
 **/